import React from 'react';
import AppBaseComponent from '../../../components/AppBaseComponent';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import { connect } from 'react-redux';
import moment from 'moment';
import DatePicker from "react-datepicker";
import Loader from "../../../components/ui/Loader/Loader";
import tapIcon from "../../../services/TapIcon";
import Ax from "../../../components/hoc/Ax";
import TapSelect from '../../../components/ui/TapSelect';
import HttpAPICall from '../../../services/HttpAPICall';
import { INVENTORY_API_BASE_URL_2, ISC_API_BASE_URL_2, ISC_INV_ADJUSTMENT_URL } from '../../../services/TapApiUrls';
import WarehouseAddress from '../includes/WarehouseAddress';
import InputItemSearch from '../../includes/ui/InputItemSearch';
import AddItemModal from '../../items/itemsAdd/AddItemModal';
import { Modal } from 'bootstrap';
import { toast } from 'react-toastify';
import ItemDetailsModal from '../../items/itemDetails/ItemDetailsModal';
import ItemEditModal from '../../items/itemsAdd/ItemEditModal';
import { Helmet } from 'react-helmet';
import ItemSearchModal from '../../items/itemSearchModal';
import DateService from '../../../services/DateService';
import AdditionalAttributeForm from '../../includes/ui/AdditionalAttributeForm';
import TapInputNumber from '../../../components/ui/TapInputNumber';
import download from '../../../services/DownloadFile';
import api from '../../../services/api';
import swal from "sweetalert";
import CurrencyService from '../../../services/CurrencyService';

class InventoryAdjustmentAdd extends AppBaseComponent {
    
    constructor(props) {
        super(props);
        
        this.initAdjustmentForm        =   {
            transaction_date            :   moment(new Date(),'YYYY-MM-DD').format('YYYY-MM-DD'),
            warehouse_id                    :   '',
            items                           :   [],
            notes                           :   '',
            adjustment_amount               :   0,
            status                          :  ''
        }
        
        this.initAdjustmentItemRows   =   [{
            item                            :   null,
            remark                          :   '',
            free_qty                        :   0,
            new_qty                         :   0,
            add_qty                         :   0,
            subtract_qty                    :   0,
            current_stocks                  :   [],
            stock_loading                   :   false,
            adjustment_type                 :   'add' ,
            adjustment_item_id              :    '',
            allApiCallsCompleted            :   false,
        }];
        
        this.initalState                =   {
            adjustmentFormDataLoaded       :   false,
            allWarehouses                   :   [],
            addAdjustmentForm               :   {...this.initAdjustmentForm},
            adjustmentItemRows             :   [...this.initAdjustmentItemRows] ,
            warehouseDetailLoading          :   false,
            warehouseDetail                :   null, 
            warehouseSites                 :   [],
            allStatus                      :   [],
            formData                       :   null,
            track_batch_expiry             :   'N' ,
            itemSearchedDetails            :    null,
            itemRowNumber                   :   0  ,
            saveFormSubmitting              :   false,
            buttonDisabled                  :       false, 
            showItemSearchModal             :       false,
            showItemAddModal                :       false,
            showItemEditModal               :       false 
        }
        
        this.state                      =   {
            ...this.initalState
        }
        this.addItemModalRef            =   React.createRef();
        this.editItemModalRef            =   React.createRef();
        this.itemSearchRef              =         React.createRef();
        this.itemDetailsRef             =   React.createRef();
        this.scannerBuffer              =   '';
        this.scannerKeyTimer            =   null;

        this.invAdjustmentUrl       =   INVENTORY_API_BASE_URL_2 + '/inventory_adjustment';
        this.warehouseUrl           =   ISC_API_BASE_URL_2  + '/warehouse';
        this.vendorUrl              =   INVENTORY_API_BASE_URL_2 + '/vendor';
        this.itemUrl                =   INVENTORY_API_BASE_URL_2 + '/item';
        this.itemCurrentStockUrl    =   INVENTORY_API_BASE_URL_2 + '/item_current_stock';
        this.itemsUrl                =   INVENTORY_API_BASE_URL_2 + '/items';

    }
    
    componentDidMount() {
        window.addEventListener('keydown', this.handleScannerKeyDown);

        setTimeout(() => {
        if (this.props.all_warehouses.length  > 0) {

            this.initilaizeFormData(this.props)}  
         }, 1000); 

        this.transferBulkUploadModal = new Modal( document.getElementById("transferBulkUploadModal"),  { keyboard: false, backdrop: false });
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleScannerKeyDown);
        if (this.scannerKeyTimer) {
            clearTimeout(this.scannerKeyTimer);
        }
    }

    handleScannerKeyDown = (event) => {
        const key = event.key;

        if (key === 'Enter') {
            const scannedValue = this.scannerBuffer.trim();
            if (scannedValue) {
               
                this.handleScannedValue(scannedValue);
                this.scannerBuffer = '';
            }
            return;
        }

        if (key && key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
            this.scannerBuffer += key;
        }

        clearTimeout(this.scannerKeyTimer);
        this.scannerKeyTimer = setTimeout(() => {
            this.scannerBuffer = '';
        }, 120);
    }

    normalizeStockMatchValue = (value) => {
        if (value === null || value === undefined) return '';
        return String(value).trim().replace(/^"|"$/g, '').replace(/T.*$/, '');
    };

    upsertScannedItemRow = (itemData, scannedMeta = {}, stockData = {}) => {
        const rows = [...this.state.adjustmentItemRows];
        const scannedBatch = this.normalizeStockMatchValue(
            scannedMeta.batch_number ||
            scannedMeta.b ||
            scannedMeta.batch ||
            ''
        );
        const scannedExpiry = this.normalizeStockMatchValue(
            scannedMeta.expiry_date ||
            scannedMeta.e ||
            scannedMeta.expiry ||
            scannedMeta.expiryDate ||
            ''
        );

        const currentStocks = Array.isArray(stockData.current_stocks)
            ? stockData.current_stocks
            : [];

        const matchedStock = stockData.selected_stock || currentStocks.find((stock) => {
            const stockBatch = this.normalizeStockMatchValue(stock?.batch_number ?? stock?.stock?.batch_number ?? '');
            const stockExpiry = this.normalizeStockMatchValue(stock?.expiry_date ?? stock?.expiry_date_display ?? stock?.stock?.expiry_date ?? '');
            return stockBatch === scannedBatch && stockExpiry === scannedExpiry;
        }) || null;

        const matchedBatch = scannedBatch || this.normalizeStockMatchValue(
            matchedStock?.batch_number || matchedStock?.stock?.batch_number || ''
        );
        const matchedExpiry = scannedExpiry || this.normalizeStockMatchValue(
            matchedStock?.expiry_date || matchedStock?.expiry_date_display || matchedStock?.stock?.expiry_date || ''
        );

        const existingRowIndex = rows.findIndex((row) => {
            if (!row.item || row.item.id !== itemData.id) return false;
            const rowBatch = this.normalizeStockMatchValue(row.batch_number || row.selected_stock?.batch_number || '');
            const rowExpiry = this.normalizeStockMatchValue(row.expiry_date || row.selected_stock?.expiry_date || row.selected_stock?.expiry_date_display || '');
            return rowBatch === matchedBatch && rowExpiry === matchedExpiry;
        });

        let targetIndex = existingRowIndex;
        const isExistingRow = existingRowIndex !== -1;
        if (targetIndex === -1) {
            targetIndex = rows.findIndex((row) => !row.item);
            if (targetIndex === -1) {
                rows.push({ ...this.initAdjustmentItemRows[0] });
                targetIndex = rows.length - 1;
            }
        }

        const existingRow = rows[targetIndex] || {};
        const nextQty = Number(existingRow.qty || existingRow.subtract_qty || existingRow.add_qty || 0) + 1;
        const adjustmentType = isExistingRow ? existingRow.adjustment_type || 'subtract' : 'subtract';

        rows[targetIndex] = {
            ...existingRow,
            item: itemData,
            remark: existingRow.remark || '',
            qty: nextQty,
            rate: existingRow.rate || itemData.consumption_price || 0,
            base_consumption_rate: existingRow.base_consumption_rate || itemData.consumption_price || 0,
            adjustment_type: adjustmentType,
            batch_number: matchedBatch || existingRow.batch_number || '',
            expiry_date: matchedExpiry || existingRow.expiry_date || '',
            current_stocks: currentStocks,
            selected_stock: matchedStock || existingRow.selected_stock || null,
            free_qty: Number(matchedStock ? (matchedStock?.stock?.free_qty ?? matchedStock?.free_qty ?? 0) : (existingRow.free_qty ?? 0)),
            allApiCallsCompleted: true,
            stock_loading: false,
        };

        if (adjustmentType === 'subtract') {
            rows[targetIndex].subtract_qty = Number(rows[targetIndex].subtract_qty || 0) + 1;
            rows[targetIndex].add_qty = 0;
            rows[targetIndex].new_qty = Number(rows[targetIndex].free_qty || 0) - Number(rows[targetIndex].subtract_qty || 0);
        } else {
            rows[targetIndex].add_qty = Number(rows[targetIndex].add_qty || 0) + 1;
            rows[targetIndex].subtract_qty = 0;
            rows[targetIndex].new_qty = Number(rows[targetIndex].free_qty || 0) + Number(rows[targetIndex].add_qty || 0);
        }

        this.setState({ adjustmentItemRows: rows }, () => {
            this.handleButtonEnable();
        });
    };

    handleScannedValue = (scannedValue) => {
        let payload = scannedValue;
        let itemCode = '';

        try {
            const parsed = JSON.parse(scannedValue);
            if (parsed && (parsed.i || parsed.item_code || parsed.code)) {
                payload = parsed;
                itemCode = parsed.i || parsed.item_code || parsed.code;
            }
        } catch (error) {
            const rawMatch = scannedValue.match(/"i"\s*:\s*"([^"]+)"|item_code\s*[:=]\s*([A-Za-z0-9\-_.]+)/i);
            if (rawMatch) {
                itemCode = rawMatch[1] || rawMatch[2];
            }
        }

        if (!itemCode) {
            itemCode = typeof payload === 'string' ? payload : '';
        }

        if (!itemCode) {
            return;
        }

        const finalItemCode = String(itemCode).trim();
        if (!finalItemCode) {
            return;
        }

        HttpAPICall.withAthorization('GET', this.itemUrl, this.props.access_token, { search_by_text: finalItemCode, page: 1, per_page: 10 }, {}, (resp) => {
            const itemData = resp && resp.data && resp.data.data && resp.data.data.length > 0 ? resp.data.data[0] : null;
            if (!itemData) {
                toast.error('No item found for scanned code: ' + finalItemCode, { position: toast.POSITION.TOP_RIGHT });
                return;
            }

            const stockParams = {
                need_weighted_average_cost: this.state.isc_item_weighted_average_cost,
                interchangeable_items_current_stock: 'N',
                warehouse_id: this.state.addAdjustmentForm.warehouse_id
            };

            HttpAPICall.withAthorization('GET', this.itemCurrentStockUrl + '/' + itemData.id, this.props.access_token, stockParams, {}, (stockResp) => {
                const stockList = Array.isArray(stockResp?.data?.current_stock) ? stockResp.data.current_stock : [];
                const currentStocks = stockList.map((cs) => ({
                    value: cs.free_qty,
                    label: (
                        <Ax>
                            <b>Batch Number : </b> {cs.batch_number}
                            <br />
                            <b>Expiry Date : </b> {cs.expiry_date_display}
                            <br />
                            <b>Free Qty : </b> {cs.free_qty}
                        </Ax>
                    ),
                    stock: cs,
                    batch_number: cs.batch_number || null,
                    expiry_date: cs.expiry_date || null,
                    expiry_date_display: cs.expiry_date_display || null,
                    display_label: `${cs.batch_number} & ${cs.expiry_date_display} `,
                }));

                const matchedStock = currentStocks.find((stock) => {
                    const stockBatch = this.normalizeStockMatchValue(stock?.batch_number ?? stock?.stock?.batch_number ?? '');
                    const stockExpiry = this.normalizeStockMatchValue(stock?.expiry_date ?? stock?.expiry_date_display ?? stock?.stock?.expiry_date ?? '');
                    const payloadBatch = this.normalizeStockMatchValue(payload?.b || payload?.batch_number || payload?.batch || '');
                    const payloadExpiry = this.normalizeStockMatchValue(payload?.e || payload?.expiry_date || payload?.expiry || payload?.expiryDate || '');
                    return stockBatch === payloadBatch && stockExpiry === payloadExpiry;
                }) || (currentStocks.length === 1 ? currentStocks[0] : null);

                this.upsertScannedItemRow(itemData, payload, {
                    current_stocks: currentStocks,
                    selected_stock: matchedStock?.stock || null,
                });
            }).catch(() => {
                this.upsertScannedItemRow(itemData, payload, { current_stocks: [], selected_stock: null });
            });
        }).catch(() => {
            toast.error('Unable to fetch item for scanned code', { position: toast.POSITION.TOP_RIGHT });
        });
    }

    // componentWillReceiveProps(nextProps){
    //     if(this.props.location && this.props.location.state){
    //         if(nextProps.location.state !== this.props.location.state) {
    //             this.initilaizeFormData(nextProps)
    //          }  
    //     }        
    // }
    
    initilaizeFormData = (pr) => {
    let sites = this.props.iam_group_sites;
    if (!this.state.adjustmentFormDataLoaded) {
        HttpAPICall.withAthorization('GET', this.invAdjustmentUrl + '/add_form_data', this.props.access_token, null, null, (response) => {
            let formData = response.data;
            this.setState({
                adjustmentFormDataLoaded: formData ? true : false,
                allWarehouses: this.props.all_warehouses.map((m) => { return { value: m.id, label: `${m.name} (${m.code})` } }),
                formData: formData,
                allStatus: formData && formData.status && formData.status.length > 0 ? formData.status.map((s) => { return { value: s.id, label: s.name }; }) : [],
                track_batch_expiry: pr.isc_configuration && pr.isc_configuration.track_batch_expiry ? pr.isc_configuration.track_batch_expiry : 'N',
                isc_prevent_back_day_voucher           :    pr.isc_setting && pr.isc_setting.isc_prevent_back_day_voucher && pr.isc_setting.isc_prevent_back_day_voucher ? pr.isc_setting.isc_prevent_back_day_voucher : 'N',
                isc_item_weighted_average_cost           :    pr.isc_setting && pr.isc_setting.isc_item_weighted_average_cost && pr.isc_setting.isc_item_weighted_average_cost ? pr.isc_setting.isc_item_weighted_average_cost : 'N',
                },() => {
                
                if (pr.location && pr.location.state && pr.location.state.adjustmentViewData) {
                   this.setState({ buttonDisabled: true });
                    let adjustmentDetail = pr.location.state.adjustmentViewData;
                    let isClone = pr.location && pr.location.state && pr.location.state.clone ? true : false;
                    let updateFormState = [];
                    
                    if (adjustmentDetail.additional_attributes_data) {
                        adjustmentDetail.additional_attributes_data.forEach((i) => {
                            updateFormState['additional_attributes_' + i.key] = i.value;
                        });
                    }

                    setTimeout(() => {
                        this.setState({
                            // Keep adjustmentDetail even for clones so batch matching logic runs
                            adjustmentDetail: isClone ? null : adjustmentDetail, 
                            addAdjustmentForm: {
                                ...this.initAdjustmentForm,
                                transaction_id: isClone ? null : adjustmentDetail.transaction_id,
                                transaction_date: isClone ? moment(new Date()).format('YYYY-MM-DD') : adjustmentDetail.transaction_date,
                                warehouse_id: adjustmentDetail.warehouse_id,
                                notes: adjustmentDetail.notes,
                                status: adjustmentDetail.status_data.id,
                                ...updateFormState,
                            },
                        }, () => {
                            this.getWarehouseDetail(adjustmentDetail.warehouse_id, true);
                            
                            // Map items but strip IDs if cloning to prevent overwriting original record
                            const itemsToProcess = adjustmentDetail.items.map(it => ({
                                ...it,
                                id: isClone ? '' : it.id,
                                adjustment_item_id: isClone ? '' : it.id
                            }));
                            this.getItemDetailsWithStocks(itemsToProcess);
                        });
                        this.addNewItemRow();
                    }, 500);

                } else if (pr.location && pr.location.state && pr.location.state.addFromClosingStockData) {
                    // PRESERVED RUNNING LOGIC FOR CLOSING STOCK
                    let adjustmentDetail = pr.location.state.addFromClosingStockData;
                    let adjustmentItems = adjustmentDetail.items;
                    this.setState({ buttonDisabled: true });
                    setTimeout(() => {
                        this.setState({
                            adjustmentDetail: null,
                            addAdjustmentForm: {
                                ...this.initAdjustmentForm,
                                transaction_id: '',
                                transaction_date: moment(new Date()).format('YYYY-MM-DD'),
                                warehouse_id: adjustmentDetail.warehouse_id,
                            },
                        }, () => {
                            this.getWarehouseDetail(adjustmentDetail.warehouse_id, true);
                            const normalizedItems = adjustmentItems.map(it => {
                                const stock = it.stock || {};
                                return {
                                    item_id: it.item?.id,
                                    item: it.item,
                                    rate: stock.rate || it.rate || 0,
                                    remark: '',
                                    batch_number: stock.batch_number || null,
                                    expiry_date: stock.expiry_date ? DateService.dateTimeFormat(stock.expiry_date, 'YYYY-MM-DD') : null,
                                    qty: '-0',
                                    id: '',
                                    adjustment_type: 'subtract',
                                    adjustment_from: 'closing_stock',
                                };
                            });
                            this.getItemDetailsWithStocks(normalizedItems);
                        });
                        this.addNewItemRow();
                    }, 1500);
                }
            });
        });
    }
}

    
    onWarehouseChange                   =   (selectedOption) =>  {
        // this.setState({
        //     adjustmentItemRows         :   [...this.initAdjustmentItemRows]
        // }, () => {
            this.getWarehouseDetail(selectedOption ? selectedOption.value : null);
        //});
    }
    
    getWarehouseDetail                  =   (warehouse_id)  =>  {
        if (warehouse_id) {
            this.setState({warehouseDetailLoading : true, warehouseDetail : null, warehouseSites : []});
            HttpAPICall.withAthorization('GET', this.warehouseUrl + '/' + warehouse_id, this.props.access_token, {}, {}, (resp) => {
                let respData = resp.data;
                this.setState({
                    warehouseDetail         :   respData.data,
                    warehouseSites          :   respData.data.sites
                },() => {
                   if(this.state.adjustmentItemRows.length > 0){
                         this.getItemDetailsWithStocks(this.state.adjustmentItemRows)
                   }
                });
               
            }).then(() => {
                this.setState({warehouseDetailLoading : false});
            });
        } else {
            this.setState({warehouseDetail: null})
        }
    }
 
    itemViewModalInit                       =   (item,k)  =>  {
        if(item){
            this.itemDetailsRef.current.modalInit(item);
            this.setState({itemRowNumber : k})
        }

    }

    addRemark       =   (data,k)      =>      {
        let allRows                 =   this.state.adjustmentItemRows;
        let itemdata = {...data,isAddRemark : true}
        allRows[k]                  =   {...this.state.adjustmentItemRows[k] , item  : itemdata};
        this.setState({adjustmentItemRows : allRows});
    }

     //********************EDIT ITEM DETAILS ******************************* */
    itemSearchModalInit             =       ()          =>      {
        this.setState(prevState => ({ showItemSearchModal: !prevState.showItemSearchModal }), () => {
            if (this.state.showItemSearchModal) {
                let allRows                 =   this.state.adjustmentItemRows;
                let item_ids                =   [];
                if(allRows && allRows.length > 0){
                    item_ids = allRows.filter(i => i.item ? true : false).map(item => {return(item?.item?.id)} )
                }
                if (this.itemSearchRef.current) {
                    this.itemSearchRef.current.searchItemModalInit(item_ids);
                }
            }
        });
        
    }

    editItemModalInit          =       (data,k)           =>      {
        this.setState(prevState => ({ showItemEditModal: !prevState.showItemEditModal,itemSearchedDetails:data,itemRowNumber:k }), () => {
            if (this.state.showItemEditModal) {
                let allRows                 =   this.state.adjustmentItemRows;
                let item_ids                =   [];
                if(allRows && allRows.length > 0){
                    item_ids = allRows.filter(i => i.item ? true : false).map(item => {return(item?.item?.id)} )
                }
                if(this.editItemModalRef.current){
                    this.editItemModalRef.current.itemEditModalInit(data); 
                }
                
            }
        });
        
    }

    addItemModalInit          =       ()           =>      {
        this.setState(prevState => ({ showItemAddModal: !prevState.showItemAddModal }), () => {
            if (this.state.showItemAddModal) {
                let allRows                 =   this.state.adjustmentItemRows;
                let item_ids                =   [];
                if(allRows && allRows.length > 0){
                    item_ids = allRows.filter(i => i.item ? true : false).map(item => {return(item?.item?.id)} )
                }

                if(this.addItemModalRef.current){
                    this.addItemModalRef.current.itemAddModalInit(); 
                }
            
            }
        });
        
    }
    
    submitEditItem          =       ()      =>      {
        HttpAPICall.withAthorization('GET', this.itemUrl + '/' + this.state.itemSearchedDetails.id, this.props.access_token, null, null, (response) => {
           let selectedItem = {
                label               :   (<Ax>
                                            <b>Item : </b> {response.data.data.name} <small> ({response.data.data.item_code})</small><br/>
                                            <small>
                                                <b>Manufacturer : </b> {response.data.data.manufacturer ? response.data.data.manufacturer.name : ''}<br/>
                                                <b>MPN : </b> {response.data.data.manufacturer_part_no}</small></Ax>),
                value               :   response.data.data.id ,
                display_label       :   `${response.data.data.name} (${response.data.data.item_code})`,
                itemdata            :   {...response.data.data}
            };
            this.setState({
                  itemSearchedDetails        :    {...response.data.data,...this.state.itemSearchedDetails}
               },() => {
                   this.onItemSelect(selectedItem,this.state.itemRowNumber,1,response?.data?.data?.consumption_price,false)
               });
        })
       
    }

    closeEvent              =           ()      =>      {
        // if(this.state.adjustmentDetail){
        //     this.props.history.push({pathname: `/consumption_list`, state: {consumptionData : this.state?.adjustmentDetail }})
        // }else{
            this.props.history.push({pathname: `/inventory_adjustment_list`})
        //}
    }

    addItemsfromSearch          =       (selectedItems)     =>  {
        let adjustmentItemRows = selectedItems.map((pu_item, k) => {
            return {
                item                        :          {...pu_item.item,isAddRemark : pu_item.remark ? true : false},
                id                          :           pu_item.item.id,
                rate                        :           pu_item.rate,
                remark                      :           '',
                expiry_date                 :           '',
                batch_number                :           '',
                adjustment_type             :           'add',
                add_qty                     :           0,
                new_qty                     :           0,
                subtract_qty                :           0
            };
        });
        let allRows = this.state.adjustmentItemRows ?  this.state.adjustmentItemRows.filter(i => i.item ? true : false) : [];
        let adjustmentItems = allRows.concat(adjustmentItemRows);
        adjustmentItems.forEach((consumedItem, key) => {
            this.onItemSelect({...consumedItem , itemdata : {...consumedItem.item,isAddRemark : consumedItem?.remark ? true : false}}, key,consumedItem.rate,null,false );
        });
        
    
    }

    convertCurrencyWithAPI = async (amount, fromCurrency, toCurrency) => {
        if (!amount || amount === 0) return amount;
        if (fromCurrency === toCurrency) return amount;

        try {
            const converter = new CurrencyService(this.props.access_token);
            return await converter.convert(amount, fromCurrency, toCurrency);
        } catch (error) {
            return amount; // Fallback to original amount
        }
    }

    getItemDetailsWithStocks = async (adjustmentItems) => {
        this.setState({ buttonDisabled: true });

        const itemIds = adjustmentItems
            .map(i => i.item_id || i.item?.id)
            .filter(Boolean);

        if (!itemIds.length) return;

        HttpAPICall.withAthorization(
            'GET',
            this.itemsUrl,
            this.props.access_token,
            {
                item_ids: itemIds,
                current_stock: 'Y',
                need_weighted_average_cost: this.state.isc_item_weighted_average_cost,
                warehouse_id: this.state.addAdjustmentForm.warehouse_id
            },
            {},
            async (resp) => {

                const respData = resp.data;
                const adjustmentItemRows = [...this.state.adjustmentItemRows];

                await Promise.all(
                    adjustmentItems.map(async (adjustmentItem, key) => {

                        const itemData = respData.data.find(
                            i => i.id === (adjustmentItem.item_id || adjustmentItem.item?.id)
                        );

                        if (itemData) {

                            let currentStocks = itemData.current_stock
                                ? itemData.current_stock.map(cs => ({
                                    value: cs.free_qty,
                                    label: (
                                        <Ax>
                                            <b>Batch Number : </b> {cs.batch_number}
                                            <br />
                                            <b>Expiry Date : </b> {cs.expiry_date_display}
                                            <br />
                                            <b>Free Qty : </b> {cs.free_qty}
                                        </Ax>
                                    ),
                                    stock: cs,
                                    batch_number: cs.batch_number || null,
                                    expiry_date: cs.expiry_date || null,
                                    expiry_date_display: cs.expiry_date_display || null,
                                    display_label: `${cs.batch_number} & ${cs.expiry_date_display} `
                                }))
                                : [];

                            // Re-select same batch & expiry
                            let selectedStock =
                                currentStocks.find(
                                    cs =>
                                        cs.batch_number === adjustmentItem.batch_number &&
                                        cs.expiry_date === adjustmentItem.expiry_date
                                ) ||
                                (currentStocks.length === 1
                                    ? currentStocks[0]
                                    : null);

                            let freeQty = selectedStock
                                ? parseFloat(selectedStock.stock.free_qty || 0)
                                : 0;

                            let qtyStr = String(adjustmentItem.qty || "");

                            let absQty =
                                parseFloat(qtyStr.replace(/[+-]/g, '')) || 0;

                            let isSubtract =
                                qtyStr.includes('-') ||
                                adjustmentItem.adjustment_type === 'subtract';

                            const isStatusLevelOne =
                                this.state.adjustmentDetail?.status_data?.level == 1;
                            const adjustedFreeQty = this.state.adjustmentDetail && !isStatusLevelOne
                                ? (isSubtract ? freeQty + absQty : freeQty - absQty)
                                : freeQty;

                            /* ================= RATE ================= */
                            // Default to consumption price; use selected-batch weighted average only for subtract.
                            let baseConsumptionRate = adjustmentItem.rate || itemData.consumption_price || 0;
                            let rate = baseConsumptionRate;
                            if (
                                this.state.isc_item_weighted_average_cost == 'Y' &&
                                !this.state.adjustmentDetail &&
                                isSubtract
                            ) {
                                const stockWeighted = selectedStock?.stock?.weighted_average_cost ?? null;
                                if (stockWeighted !== null && stockWeighted !== undefined && stockWeighted !== '') {
                                    rate = stockWeighted;
                                }
                            }

                            /* ================= CURRENCY CONVERSION ================= */

                            try {

                                const fromCurrency =
                                    itemData.currency_code ||
                                    itemData.consumption_currency ||
                                    "INR";

                                const toCurrency =
                                    this.state.formData?.currency_code || "INR";

                                if (
                                    fromCurrency &&
                                    toCurrency &&
                                    fromCurrency !== toCurrency
                                ) {

                                    if (Number(baseConsumptionRate) > 0) {
                                        baseConsumptionRate = await this.convertCurrencyWithAPI(
                                            Number(baseConsumptionRate),
                                            fromCurrency,
                                            toCurrency
                                        );
                                    }

                                    if (Number(rate) > 0) {
                                        const convertedRate =
                                            await this.convertCurrencyWithAPI(
                                                Number(rate),
                                                fromCurrency,
                                                toCurrency
                                            );

                                        rate = !this.state.adjustmentDetail ? convertedRate : rate;
                                    }
                                }

                            } catch (e) {
                            }

                            adjustmentItemRows[key] = {
                                ...adjustmentItemRows[key],

                                item: {
                                    ...itemData,
                                    isAddRemark: adjustmentItem.remark
                                        ? true
                                        : false
                                },

                                remark: adjustmentItem.remark || '',

                                rate,
                                base_consumption_rate: baseConsumptionRate,

                                adjustment_type: isSubtract
                                    ? 'subtract'
                                    : 'add',

                                batch_number:
                                    adjustmentItem.batch_number || '',

                                expiry_date:
                                    adjustmentItem.expiry_date || '',

                                free_qty: adjustedFreeQty,

                                add_qty: isSubtract
                                    ? 0
                                    : absQty,

                                subtract_qty: isSubtract
                                    ? absQty
                                    : 0,

                                new_qty: isSubtract
                                    ? (adjustedFreeQty - absQty)
                                    : (adjustedFreeQty + absQty),

                                current_stocks: currentStocks,

                                selected_stock:
                                    selectedStock?.stock || null,

                                allApiCallsCompleted: true,

                                stock_loading: false,

                                qty: absQty,
                            };
                        }
                    })
                );

                this.setState(
                    {
                        adjustmentItemRows:
                            adjustmentItemRows.filter(i => i.item),

                        buttonDisabled: false
                    },
                    () => this.handleButtonEnable()
                );
            }
        );
    };

    onItemSelect = async (
        selectedOption,
        key,
        qty = 1,
        purchase_price = null,
        pre_selected_stock = null,
        addRow = true,
        adjustment_type = 'add'
    ) => {

        if (selectedOption) {

            if (!this.state.addAdjustmentForm.warehouse_id) {

                toast.error(
                    'Please select  Warehouse First',
                    { position: toast.POSITION.TOP_RIGHT }
                );

            } else {

                let adjustmentItemRows =
                    this.state.adjustmentItemRows;

                let itemdata = selectedOption.itemdata;

                if (!purchase_price) {
                    purchase_price =
                        itemdata && itemdata.consumption_price
                            ? itemdata.consumption_price
                            : 0;
                }

                /* ================= RATE ================= */

                // Always start from consumption price when item is picked.
                let rate = purchase_price;

                /* ================= CURRENCY CONVERSION ================= */

                try {

                    const fromCurrency =
                        itemdata.currency_code ||
                        itemdata.consumption_currency ||
                        "INR";

                    const toCurrency =
                        this.state.formData?.currency_code || "INR";
                         

                    if (
                        fromCurrency &&
                        toCurrency &&
                        fromCurrency !== toCurrency &&
                        Number(rate) > 0
                    ) {

                        const convertedRate =
                            await this.convertCurrencyWithAPI(
                                Number(rate),
                                fromCurrency,
                                toCurrency
                            );

                        rate = convertedRate || rate;
                    }

                } catch (e) {
                }

               
                let row = {
                    ...adjustmentItemRows[key],

                    item: itemdata,

                    qty: Number(qty),

                    rate,
                    base_consumption_rate: rate,

                    remark:
                        selectedOption.remark
                            ? selectedOption.remark
                            : "",

                    adjustment_type: adjustment_type,

                    batch_number:
                        adjustment_type == 'add'
                            ? selectedOption.batch_number
                            : '',

                    expiry_date:
                        adjustment_type == 'add'
                            ? selectedOption.expiry_date
                            : '',

                    adjustment_item_id:
                        pre_selected_stock &&
                            pre_selected_stock.adjustment_item_id
                            ? pre_selected_stock.adjustment_item_id
                            : ''
                };

                adjustmentItemRows[key] = row;

                this.setState(
                    {
                        adjustmentItemRows: [...adjustmentItemRows]
                    },
                    () => {

                        if (
                            !this.state.adjustmentItemRows.find(
                                ir => !ir.item
                            )
                        ) {
                            if (addRow == true) {
                                setTimeout(() => {
                                    this.addNewItemRow()
                                }, 1000);
                            }
                        }

                        if (
                            itemdata &&
                            itemdata.category &&
                            itemdata.category === 'services'
                        ) {

                            let adjustmentItemRows =
                                this.state.adjustmentItemRows;

                            adjustmentItemRows[key] = {
                                ...adjustmentItemRows[key],
                                allApiCallsCompleted: true,
                            };

                            this.setState(
                                {
                                    adjustmentItemRows:
                                        [...adjustmentItemRows]
                                },
                                () => {
                                    this.handleButtonEnable();
                                }
                            );

                        } else if (
                            itemdata &&
                            itemdata.category !== 'services'
                        ) {

                            this.getItemInventoryLevel(
                                itemdata.id,
                                key,
                                pre_selected_stock,
                                selectedOption
                            );
                        }
                    }
                );
            }
        }
    };

// getItemDetailsWithStocks = (adjustmentItems) => {
//     this.setState({ buttonDisabled: true });
//     const itemIds = adjustmentItems.map(i => i.item_id || i.item?.id).filter(Boolean);
//     if (!itemIds.length) return;

//     HttpAPICall.withAthorization('GET', this.itemsUrl, this.props.access_token, {
//         item_ids: itemIds,
//         current_stock: 'Y',
//         need_weighted_average_cost : this.state.isc_item_weighted_average_cost,
//         warehouse_id: this.state.addAdjustmentForm.warehouse_id
//     }, {}, (resp) => {
//         const respData = resp.data;
//         const adjustmentItemRows = [...this.state.adjustmentItemRows];

//         adjustmentItems.forEach((adjustmentItem, key) => {
//             const itemData = respData.data.find(i => i.id === (adjustmentItem.item_id || adjustmentItem.item?.id));

//             if (itemData) {
//                 let currentStocks = itemData.current_stock ? itemData.current_stock.map(cs => ({
//                     value: cs.free_qty,
//                     label: (<Ax><b>Batch Number : </b> {cs.batch_number} <br /> <b>Expiry Date : </b> {cs.expiry_date_display}<br /> <b>Free Qty : </b> {cs.free_qty}</Ax>),
//                     stock: cs,
//                     batch_number: cs.batch_number || null,
//                     expiry_date: cs.expiry_date || null,
//                     expiry_date_display: cs.expiry_date_display || null,
//                     display_label: `${cs.batch_number} & ${cs.expiry_date_display} `
//                 })) : [];

//                 // Re-select the exact same batch and expiry
//                 let selectedStock = currentStocks.find(cs =>
//                     cs.batch_number === adjustmentItem.batch_number &&
//                     cs.expiry_date === adjustmentItem.expiry_date
//                 ) || (currentStocks.length === 1 ? currentStocks[0] : null);

//                 let freeQty = selectedStock ? parseFloat(selectedStock.stock.free_qty || 0) : 0;
//                 let qtyStr = String(adjustmentItem.qty || "");
//                 let absQty = parseFloat(qtyStr.replace(/[+-]/g, '')) || 0;
                
//                 // Determine type based on the qty prefix
//                 let isSubtract = qtyStr.includes('-') || adjustmentItem.adjustment_type === 'subtract';
                    
//                 adjustmentItemRows[key] = {
//                     ...adjustmentItemRows[key],
//                     item: {...itemData,isAddRemark : adjustmentItem.remark ? true : false},
//                     remark: adjustmentItem.remark || '',
//                     rate: this.state.isc_item_weighted_average_cost == 'Y' && !this.state.adjustmentViewData ? itemData.weighted_average_cost : adjustmentItem.rate || itemData.consumption_price || 0,
//                     adjustment_type: isSubtract ? 'subtract' : 'add',
//                     batch_number: adjustmentItem.batch_number || '',
//                     expiry_date: adjustmentItem.expiry_date || '',
//                     free_qty: freeQty,
//                     add_qty: isSubtract ? 0 : absQty,
//                     subtract_qty: isSubtract ? absQty : 0,
//                     new_qty: isSubtract ? (freeQty - absQty) : (freeQty + absQty),
//                     current_stocks: currentStocks,
//                     selected_stock: selectedStock?.stock || null,
//                     allApiCallsCompleted: true,
//                     stock_loading: false,
//                     qty : absQty,
//                 };
//             }
//         });

//         this.setState({
//             adjustmentItemRows: adjustmentItemRows.filter(i => i.item),
//             buttonDisabled: false
//         }, () => this.handleButtonEnable());
//     });
// };

//     onItemSelect            =   (selectedOption, key, qty = 1,purchase_price=null, pre_selected_stock =  null,addRow = true,adjustment_type='add')  =>  {
       
//         if(selectedOption) {
//             if(!this.state.addAdjustmentForm.warehouse_id){
//                 toast.error('Please select  Warehouse First', { position: toast.POSITION.TOP_RIGHT })
//             } else {
//                 let adjustmentItemRows          =   this.state.adjustmentItemRows;
                
//                 let itemdata                    =   selectedOption.itemdata;
//                 if(!purchase_price) {
//                     purchase_price              =   itemdata && itemdata.consumption_price ? itemdata.consumption_price: 0;
//                 }
                   
//                 let row                         =   {
//                     ...adjustmentItemRows[key], 
//                     item            :   itemdata , 
//                     qty             :   Number(qty) ,
//                     rate            :   this.state.isc_item_weighted_average_cost == 'Y' ? itemdata.weighted_average_cost : purchase_price,
//                     remark          :   selectedOption.remark ? selectedOption.remark : "",
//                     adjustment_type :   adjustment_type,
//                     batch_number    :   adjustment_type == 'add' ? selectedOption.batch_number : '',
//                     expiry_date     :   adjustment_type == 'add' ? selectedOption.expiry_date : '',
//                     adjustment_item_id  :   pre_selected_stock && pre_selected_stock.adjustment_item_id ? pre_selected_stock.adjustment_item_id : ''
//                         // free_qty        :   adjustment_type == 'add' ? Number(selectedOption.qty) : '',
//                         // add_qty         :   adjustment_type == 'add' ? Number(selectedOption.qty) : 0,
//                         // new_qty         :   adjustment_type == 'add' ? Number(selectedOption.qty) : 0,
//                         // subtract_qty :   adjustment_type == 'add' ? 0 : '',
//                     };

//                     adjustmentItemRows[key]            =   row;
//                     this.setState({adjustmentItemRows : [...adjustmentItemRows]}, () => {
                        
//                         if(!this.state.adjustmentItemRows.find(ir => !ir.item)) {
//                             if(addRow == true){
//                                 setTimeout(() => {this.addNewItemRow()}, 1000);
//                             }
//                         }

//                         if (itemdata && itemdata.category && itemdata.category === 'services') {
//                             // For service items, mark API calls as completed directly
//                             let adjustmentItemRows = this.state.adjustmentItemRows;
//                             adjustmentItemRows[key] = {
//                                 ...adjustmentItemRows[key],
//                                 allApiCallsCompleted: true, // Mark as completed for service items
//                             };
//                             this.setState({ adjustmentItemRows: [...adjustmentItemRows] }, () => {
//                                 // Check button enablement
//                                 this.handleButtonEnable();
//                             });
//                         } else if (itemdata && itemdata.category !== 'services') {
//                             // Call getItemInventoryLevel only for non-service items (goods)
//                             this.getItemInventoryLevel(itemdata.id, key, pre_selected_stock, selectedOption);
//                         }
                        
//                         // if(itemdata && itemdata.category && itemdata.category !== 'services') {
//                         //     //load Inventory Level of this item at given warehouse for this key :-
//                         //     this.getItemInventoryLevel(itemdata.id, key, pre_selected_stock);
//                         // }
                        
//                     });
//             }
//         }
        
       
       
//     }
    
    getItemInventoryLevel               =   (item_id, key, pre_selected_stock = null)  =>  {
        this.setState({ buttonDisabled: true });
        let adjustmentItemRows         =   this.state.adjustmentItemRows;
        adjustmentItemRows[key]        =   {...adjustmentItemRows[key] , stock_loading : true,selected_stock:null,current_stocks:[]};
        this.setState({adjustmentItemRows : [...adjustmentItemRows]});
        let params ={
            need_weighted_average_cost: this.state.isc_item_weighted_average_cost,
            interchangeable_items_current_stock: "N", warehouse_id: this.state.addAdjustmentForm.warehouse_id
        }
        HttpAPICall.withAthorization('GET', this.itemCurrentStockUrl + '/' + item_id, this.props.access_token, params ,{} )
        .then((results) => {
            
            let current_stock_list          =           results.data;
            
                let current_stocks              =   current_stock_list.current_stock.map(cs => {
                                                        return {
                                                            value : cs.qty,
                                                            label : (<Ax><b>Batch Number : </b> {cs.batch_number} <br />
                                                                <b>Expiry Date : </b> {cs.expiry_date_display}<br />
                                                                <b>Free Qty : </b> {cs.free_qty}</Ax>),
                                                            stock : cs,
                                                            display_label: `${cs.batch_number} & ${cs.expiry_date_display} `
                                                        }
                                                    });
                let adjustmentItemRows         =   this.state.adjustmentItemRows;
                adjustmentItemRows[key]        =   {
                        ...adjustmentItemRows[key],
                        stock_loading           :       false,
                        current_stocks          :      current_stocks,
                        allApiCallsCompleted: true
                };
                
                let selectedStock               =  null;
               
                if(adjustmentItemRows && adjustmentItemRows[key] && adjustmentItemRows[key].adjustment_type == 'add'){
                   if(current_stocks && current_stocks.length > 0){
                        selectedStock            =   current_stocks.find(cs => {
                            return cs.stock.batch_number == null && cs.stock.expiry_date == null;
                        });
                   }else if(current_stocks && current_stocks.length == 0 && pre_selected_stock){
                   
                        selectedStock           =  {
                            stock : {
                                // consumption_item_id                :   pre_selected_stock.consumption_item_id,
                                batch_number            :   pre_selected_stock.batch_number,
                                expiry_date             :   pre_selected_stock.expiry_date,
                                adjustment_type         :  pre_selected_stock.adjustment_type,
                                new_qty                 :  Math.abs(pre_selected_stock.qty),
                                add_qty                 :  pre_selected_stock.adjustment_type == 'add' ? Number(pre_selected_stock.qty) : 0,
                                subtract_qty            :  pre_selected_stock.adjustment_type == 'subtract' ? Math.abs(pre_selected_stock.qty) : 0
                            }
                        };
                   }
                  
                }else{
                    
                  selectedStock =   current_stocks && current_stocks.length > 0 ? current_stocks[0] : null;
                }
                
               
                if(pre_selected_stock) {
                    let preSelectedStock            =   current_stocks.find(cs => {
                                                            return cs.stock.batch_number == pre_selected_stock.batch_number 
                                                                        && cs.stock.expiry_date == pre_selected_stock.expiry_date;
                                                      });  

                    const fallbackStock = current_stocks && current_stocks.length > 0 ? current_stocks[0].stock : null;
                    const originalQty = Number(Math.abs(pre_selected_stock?.qty || 0));
                    const isAddAdjustment = pre_selected_stock?.adjustment_type === 'add';
                    const fallbackFreeQty = fallbackStock ? Number(fallbackStock.free_qty || 0) : 0;

                    if(preSelectedStock == undefined || preSelectedStock == null) {
                        const restoredFreeQty = fallbackFreeQty;
                        selectedStock           =  {
                            ...(selectedStock || current_stocks[0] || {}),
                            stock                   :   {
                                ...(fallbackStock || {}),
                                batch_number            :   pre_selected_stock.batch_number,
                                expiry_date             :   pre_selected_stock.expiry_date,
                                adjustment_type         :   pre_selected_stock.adjustment_type,
                                new_qty                 :   restoredFreeQty,
                                free_qty                :   restoredFreeQty,
                                add_qty                 :  isAddAdjustment ? originalQty : 0,
                                subtract_qty            :  !isAddAdjustment ? originalQty : 0
                            },
                            new_stock               :   {
                                ...(fallbackStock || {}),
                                batch_number            :   pre_selected_stock.batch_number,
                                expiry_date             :   pre_selected_stock.expiry_date,
                                adjustment_type         :   pre_selected_stock.adjustment_type,
                                new_qty                 :   restoredFreeQty,
                                free_qty                :   restoredFreeQty,
                                add_qty                 :   isAddAdjustment ? originalQty : 0,
                                subtract_qty            :   !isAddAdjustment ? originalQty : 0
                            }
                        };
                    } else {
                        let cs              =   preSelectedStock.stock;
                        let qty             =   cs.qty;
                        const restoredFreeQty =
                            this.state.adjustmentDetail &&
                            this.state.adjustmentDetail.status_data &&
                            this.state.adjustmentDetail.status_data.level >= 2
                                ? (isAddAdjustment
                                    ? Number(cs.free_qty || 0) - originalQty
                                    : Number(cs.free_qty || 0) + originalQty)
                                : Number(cs.free_qty || 0);

                       selectedStock        =   {
                            ...preSelectedStock,
                            stock           :   {
                                ...cs,
                                qty             :   Number(qty),
                                free_qty        :   Number(restoredFreeQty),
                                add_qty         :   isAddAdjustment ? originalQty : 0,
                                subtract_qty    :   !isAddAdjustment ? originalQty : 0,
                                new_qty         :   Number(restoredFreeQty)
                            }
                        };
                    }
                }

                this.setState({adjustmentItemRows : [...adjustmentItemRows]} , () => {
                    this.onBatchChange(selectedStock, key);
                    this.handleButtonEnable()
                });
            
        })
     
    }

    handleButtonEnable = () => {
        // Check if all items are either processed (allApiCallsCompleted) or are services
        const allItemsProcessed = this.state.adjustmentItemRows
            .filter(i => i.item) // Ensure the item exists
            .every(item => 
                (item.allApiCallsCompleted || (item.item && item.item.category === 'services'))
            );
        
        // Enable the button only if all items are processed or are services
        this.setState({ buttonDisabled: !allItemsProcessed });
    };
    
    onBatchChange                       =   (selectedOption, key)  =>  {
       
        if(selectedOption && selectedOption.stock) {
            let selected_stock              =   selectedOption.stock;
            let new_selected_stock         =   selectedOption && selectedOption.new_stock ? selectedOption.new_stock : null;
            let adjustmentItemRows         =   this.state.adjustmentItemRows;
           
            let obj = {}
            
            const currentFreeQty = Number(selected_stock?.free_qty ?? 0);
            const editRow = adjustmentItemRows[key] || {};
            const originalAdjustmentQty =
                editRow.adjustment_type === 'add'
                    ? Number(editRow.add_qty ?? 0)
                    : Number(editRow.subtract_qty ?? 0);

            if(this.state.adjustmentDetail){
                obj['add_qty']  =       selected_stock.add_qty;
                obj['subtract_qty'] =   Number(selected_stock.subtract_qty??0);
                obj['new_qty']      =   selected_stock.new_qty;
                obj['free_qty']     =   editRow.adjustment_type === 'add'
                    ? currentFreeQty - originalAdjustmentQty
                    : currentFreeQty + originalAdjustmentQty;
            }

            if(new_selected_stock){
                obj['add_qty']  =       new_selected_stock.add_qty;
                obj['subtract_qty'] =   Number(new_selected_stock?.subtract_qty??0);
                obj['new_qty']      =   new_selected_stock.new_qty;
                obj['batch_number'] =   new_selected_stock.batch_number;
                obj['expiry_date']  =   new_selected_stock.expiry_date;
                obj['free_qty']     =   editRow.adjustment_type === 'add'
                    ? Number(new_selected_stock.free_qty ?? 0) - originalAdjustmentQty
                    : Number(new_selected_stock.free_qty ?? 0) + originalAdjustmentQty;

            }
          
             // Use weighted average only for subtract rows and only when selected stock has it.
             const existingRate = adjustmentItemRows[key]?.rate;
             const baseConsumptionRate =
                adjustmentItemRows[key]?.base_consumption_rate ??
                adjustmentItemRows[key]?.item?.consumption_price ??
                existingRate;
             let newRate = baseConsumptionRate;
             if (
                this.state.isc_item_weighted_average_cost == 'Y' &&
                adjustmentItemRows[key]?.adjustment_type === 'subtract'
             ) {
                const stockWeighted =
                    new_selected_stock?.weighted_average_cost ??
                    selected_stock?.weighted_average_cost;
                if (stockWeighted !== null && stockWeighted !== undefined && stockWeighted !== '') {
                    newRate = stockWeighted;
                }
             }

             adjustmentItemRows[key]        =   {
                ...adjustmentItemRows[key], 
                selected_stock  :   new_selected_stock ? null : selected_stock,
                base_consumption_rate: baseConsumptionRate,
                rate: newRate,
                 ...obj,
                free_qty: obj.free_qty ?? Number(selected_stock.free_qty)
               
            };
            this.setState({adjustmentItemRows : [...adjustmentItemRows]});
        }
    }

    addNewItemRow                       =   ()  =>  {
        this.setState({adjustmentItemRows : [...this.state.adjustmentItemRows, ...this.initAdjustmentItemRows ] });
    }

    removeItemRow                       =   (k) =>  {
        let adjustmentItemRows             =   this.state.adjustmentItemRows;
        if(adjustmentItemRows.length > 1) {
            adjustmentItemRows.splice(k, 1);
            this.setState({adjustmentItemRows : adjustmentItemRows});
        }
       
    }

    adjustQtyFields(itemKey, fieldName, newValue) {
        const adjustmentItemRows = [...this.state.adjustmentItemRows];
        const itemRow = adjustmentItemRows[itemKey];
      
        if (fieldName === 'new_qty') {
          const newQty = parseFloat(Number(newValue));
          const freeQty = itemRow.selected_stock ? itemRow.free_qty : 0;
          
          if (newQty >= freeQty) {
            itemRow.add_qty = newQty - freeQty;
            itemRow.subtract_qty = 0;
          } else {
            itemRow.add_qty = 0;
            itemRow.subtract_qty = freeQty - newQty;
          }
          
          itemRow.new_qty = newQty;
        } else if (fieldName === 'add_qty') {
          const addQty = parseFloat(Number(newValue));
          itemRow.add_qty = addQty;
          itemRow.subtract_qty = 0;
          itemRow.new_qty = addQty + (itemRow.selected_stock ? itemRow.free_qty : 0);
        } else if (fieldName === 'subtract_qty') {
          const subtractQty = parseFloat(Number(newValue));
          itemRow.subtract_qty = subtractQty;
          itemRow.add_qty = 0;
          itemRow.new_qty = (itemRow.selected_stock ? itemRow.free_qty : 0) - subtractQty;
        }
      
        adjustmentItemRows[itemKey] = itemRow;
       
    }

    handleRadioChange = (itemKey, adjustmentType,item_id) => {
        const adjustmentItemRows = [...this.state.adjustmentItemRows];
        const itemRow = adjustmentItemRows[itemKey];
        const selectedStock = itemRow.selected_stock;
        const freeQty = selectedStock ? Number(itemRow.free_qty || selectedStock.free_qty || 0) : 0;
        const adjustmentQty = Number(
            itemRow.adjustment_type === 'subtract'
                ? itemRow.subtract_qty || itemRow.qty || 0
                : itemRow.add_qty || itemRow.qty || 0
        );
        itemRow.qty   =   adjustmentQty;
        itemRow.free_qty  =   freeQty;
        itemRow.add_qty   =   adjustmentType === 'add' ? adjustmentQty : 0;
        itemRow.subtract_qty  =   adjustmentType === 'subtract' ? adjustmentQty : 0;
        itemRow.new_qty       =   adjustmentType === 'add'
            ? freeQty + adjustmentQty
            : freeQty - adjustmentQty;
        itemRow.rate          =   itemRow.base_consumption_rate ?? itemRow.item?.consumption_price ?? itemRow.rate;
        
        itemRow.adjustment_type = adjustmentType;
        this.setState({ adjustmentItemRows : adjustmentItemRows },() => {
            if (adjustmentType == 'subtract' || !selectedStock) {
                this.getItemInventoryLevel(item_id, itemKey);
            } else {
                this.handleButtonEnable();
            }
        });
    };

    transferBulkUploadModalInit = () => {
        document.getElementById("addTransferFileSelector").value = null;

        this.transferBulkUploadModal.show();
    };

    transferBulkUploadFormSubmit = (event) => {
            event.preventDefault();
            this.setState({ transferBulkUploadFormSubmiting: true });
    
            const formElement = document.getElementById("transferBulkUploadForm");
            const formData = new FormData(formElement);
    
            // Add warehouse IDs to FormData
            formData.append('warehouse_id', this.state.addAdjustmentForm.warehouse_id);
           // formData.append('only_stocked_item', this.state.addInventoryTransferForm.only_stocked_item);
    
            const headers = {
                'Authorization': 'Bearer ' + this.props.access_token,
            };
    
            api.server2Api.post(
                ISC_INV_ADJUSTMENT_URL + '/item_upload_excel',
                formData,
                { headers: headers }
            )
                .then((response) => {
                   
                    toast.success(response.data?.msg || "Items uploaded successfully", {
                        position: toast.POSITION.TOP_RIGHT
                    });
                  
                    //Process the uploaded items and add them to the inventory transfer
                    if (response.data && response.data.data) {
                        this.processUploadedItems(response.data.data);
                    }
                     if (response.data.generated_file && response.data.generated_file.file_path) {
                        download.file(response.data.generated_file.file_path);
                    }
    
                    this.transferBulkUploadModal.hide();
                })
                .catch((err) => {
                    toast.error(
                        err?.response?.data?.message || "Unable to upload Item Add File.",
                        { position: toast.POSITION.TOP_RIGHT }
                    );
                })
                .finally(() => {
                    this.setState({ transferBulkUploadFormSubmiting: false });
                });
    }

     downloadSampleFile = () => {
          HttpAPICall.withAthorization(
            "GET",
            ISC_INV_ADJUSTMENT_URL + "/item_upload_sample_excel",
            this.props.access_token,
            {},
            {},
            (response) => {
              download.file(response.data.file_path);
              toast.success("File Downloaded Successfully", {
                position: toast.POSITION.TOP_RIGHT,
              });
              this.transferBulkUploadModal.hide();
            }
          );
    };

processUploadedItems = async (uploadedItems = []) => {
    if (!Array.isArray(uploadedItems) || uploadedItems.length === 0) {
        toast.error("No items found in uploaded file");
        return;
    }

    const warehouseId = this.state.addAdjustmentForm.warehouse_id;
    const defaultCurrency = this.props.defaultCurrency || this.state.defaultCurrency || "INR";

    let existingRows = this.state.adjustmentItemRows.filter(r => r.item);
    const existingItemIds = new Set(existingRows.map(r => r.item.id));

    const newRows = [];

         
        for (const uItem of uploadedItems) {
    const itemData = uItem.item_data;
    if (!itemData || !itemData.id) continue;

    if (existingItemIds.has(itemData.id)) continue;

    const addQty = Number(uItem.add_qty || 0);
    const subtractQty = Number(uItem.substract_qty || 0);
    const adjustmentType = subtractQty > 0 ? 'subtract' : 'add';
      
    // ---------- STOCK HANDLING ----------
    let currentStocks = [];
    let selectedStock = null;

    if (Array.isArray(itemData.current_stock)) {
        currentStocks = itemData.current_stock
            .filter(cs => cs.warehouse_id === warehouseId)
            .map(cs => ({
                value: cs.free_qty,
                label: (
                    <Ax>
                        <b>Batch Number : </b> {cs.batch_number}
                        <br />
                        <b>Expiry Date : </b> {cs.expiry_date}
                        <br />
                        <b>Free Qty : </b> {cs.free_qty}
                    </Ax>
                ),
                stock: {
                    ...cs,
                    expiry_date_display: cs.expiry_date,
                    id: cs.stock_id || cs.id
                },
                batch_number: cs.batch_number,
                expiry_date: cs.expiry_date,
                qty: cs.qty,
                free_qty: cs.free_qty,
                display_label: `${cs.batch_number} & ${cs.expiry_date}`
            }));

        if (uItem.selected_stock) {
            selectedStock = currentStocks.find(cs =>
                cs.batch_number === uItem.selected_stock.batch_number &&
                cs.expiry_date === uItem.selected_stock.expiry_date
            );
        }

        if (!selectedStock && (uItem.batch_number || uItem.expiry_date)) {
            selectedStock = currentStocks.find(cs =>
                cs.batch_number === uItem.batch_number &&
                cs.expiry_date === uItem.expiry_date
            );
        }

        if (!selectedStock && currentStocks.length === 1) {
            selectedStock = currentStocks[0];
        }
    }

    const freeQty = selectedStock ? Number(selectedStock.free_qty || 0) : 0;

    const newQty =
        adjustmentType === 'add'
            ? freeQty + addQty
            : freeQty - subtractQty;
            
    // Default base rate to consumption price.
    let baseConsumptionRate = uItem.item_rate || 0;
    let rate = baseConsumptionRate;

    // For subtract, prefer selected-batch weighted average when enabled and available.
    if (
        adjustmentType === 'subtract' &&
        this.state.isc_item_weighted_average_cost == 'Y'
    ) {
        const stockWeighted = selectedStock?.stock?.weighted_average_cost;
        if (stockWeighted !== null && stockWeighted !== undefined && stockWeighted !== '') {
            rate = stockWeighted;
        }
    }

    // ✅ ONLY FIX: safe async currency conversion
    const fromCurrency = itemData.consumption_currency || defaultCurrency;
    const toCurrency = defaultCurrency;

    if (fromCurrency !== toCurrency) {
        try {
            if (baseConsumptionRate > 0) {
                baseConsumptionRate = await this.convertCurrencyWithAPI(baseConsumptionRate, fromCurrency, toCurrency);
            }
            if (rate > 0) {
                rate = await this.convertCurrencyWithAPI(rate, fromCurrency, toCurrency);
            }
        } catch (error) {
        }
    }

    newRows.push({
        item: itemData,
        remark: uItem.remark || '',
        rate,
        base_consumption_rate: baseConsumptionRate,

        adjustment_type: adjustmentType,
        adjustment_item_id: uItem.id || '',

        batch_number: adjustmentType === 'add' ? uItem.batch_number || '' : '',
        expiry_date: adjustmentType === 'add' ? uItem.expiry_date || '' : '',

        add_qty: adjustmentType === 'add' ? addQty : 0,
        subtract_qty: adjustmentType === 'subtract' ? subtractQty : 0,
        free_qty: freeQty,
        new_qty: newQty,

        current_stocks: currentStocks,
        selected_stock: selectedStock,

        allApiCallsCompleted: true,
        stock_loading: false
    });
}

        if (newRows.length === 0) {
            toast.warning("All uploaded items already exist");
            return;
        }

        this.setState(
            {
                adjustmentItemRows: [
                    ...existingRows,
                    ...newRows,
                    { ...this.initAdjustmentItemRows[0] }
                ],
                buttonDisabled: false
            },
            () => {
                toast.success(`${newRows.length} items added successfully`);
                this.handleButtonEnable();
            }
        );
    };

    transferBulkUploadModalJsx = () => {
        return (
            <div className="modal fade" id="transferBulkUploadModal" tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="itemBulkUploadModalLabel">
                                Bulk Add Items
                            </h5>
                            <button
                                type="button"
                                disabled={this.state.transferBulkUploadFormSubmiting}
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <form
                            onSubmit={this.transferBulkUploadFormSubmit}
                            id="transferBulkUploadForm"
                            method="post"
                            encType="multipart/form-data"
                        >
                            <div className="modal-body">
                                <div className="row align-items-center mb-3 mt-3">
                                    <div className="col-12">
                                        <input
                                            name="document"
                                            id="addTransferFileSelector"
                                            type="file"
                                            className="form-control"
                                            required={true}
                                        />
                                    </div>
                                    <div className="col-12 mt-2 form-text">
                                        # Excel Sheet with Extention xls,xlm,xlsx,ods Allowed
                                    </div>
                                    <div className="col-12 mt-2 form-text">
                                        # Miximum 100 MB Size of Excel Sheet Allowed
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer d-flex justify-content-between">
                                <div>
                                    <a
                                        type="button"
                                        className="float-left"
                                        href="#"
                                        onClick={this.downloadSampleFile}
                                    >
                                        Download Sample File
                                    </a>
                                </div>
                                <div>
                                    <button
                                        type="button"
                                        disabled={this.state.transferBulkUploadFormSubmiting}
                                        className="btn btn-secondary mx-2"
                                        data-bs-dismiss="modal"
                                    >
                                        Close
                                    </button>
                                    <button
                                        type="submit"
                                        disabled={this.state.transferBulkUploadFormSubmiting}
                                        className="btn btn-primary"
                                    >
                                        Submit{" "}
                                        {this.state.transferBulkUploadFormSubmiting ? (
                                            <tapIcon.FontAwesomeIcon
                                                icon={tapIcon.faSyncAlt}
                                                className="fa-spin"
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    };
      
    adjustmentFormSubmitHandler       =       (e,status)     =>      {
        
        let showErrors                  =   [];
        let formData                        =   {...this.state.addAdjustmentForm, status : status};
       
        let items                           =   this.state.adjustmentItemRows.filter(ir => ir.item).map(i => {
                                                  
                                                   let batch_number = '',expiry_date='';
                                                    if(i.adjustment_type !== 'add' && i.selected_stock && i.selected_stock.batch_number ){
                                                        batch_number =  i.selected_stock.batch_number;
                                                        expiry_date  =   i.selected_stock.expiry_date;
                                                    }else if(i.new_stock && i.new_stock.batch_number){
                                                      
                                                        batch_number =  i.new_stock.batch_number;
                                                        expiry_date  =   i.new_stock.expiry_date;
                                                        //}
                                                    }else {
                                                        batch_number = i.batch_number;
                                                        expiry_date=i.expiry_date;
                                                    }
                                                    
                                                    return {
                                                        id                  :   i.item.id,
                                                        batch_number        :   batch_number,
                                                        expiry_date         :   expiry_date,
                                                        qty                 :   i.adjustment_type == 'add' ? `+${i.add_qty}`  : `-${i.subtract_qty}`,
                                                        rate                :   i.rate,
                                                        remark              :   i.remark,
                                                        new_qty             :   i.new_qty,
                                                        adjustment_item_id  :   i.adjustment_item_id ? i.adjustment_item_id : ''
                                                    };
                                                });
                
        let additional_attributes = {};
        this.state.formData.additional_attributes.forEach((i, k) => {
            let name = 'additional_attributes_' + i.key;
            additional_attributes[i.key] = this.state.addAdjustmentForm[name] ? this.state.addAdjustmentForm[name] : '';
        });

        let allItemLists                    =            [];
        let dublicateItemExists             =            false;                                                  
        if(items.length > 0){
            items.forEach(item => {

                let combinationKey          =           item.id  + item.batch_number + item.expiry_date + item.adjustment_type;
                if (allItemLists.includes(combinationKey)) {
                    dublicateItemExists = true;
                }
                return allItemLists.push(combinationKey); 
            })
        }   
                                          
        if(formData.transaction_date == '') {
            showErrors                      =   [...showErrors , 'Please enter Transaction Date.'];
        }
        
        if(formData.warehouse_id == '') {
            showErrors                      =   [...showErrors , 'Please select Warehouse.'];
        }
       

        if(formData.status == '') {
            showErrors                      =   [...showErrors , 'Please select Status'];
        }
        
        if(items.length == 0) {
            showErrors                      =   [...showErrors , 'Please select Item and qty.'];
        }else if(dublicateItemExists == true) {
            showErrors                      =   [...showErrors , 'Inventory Adjustment should not contain duplicate Item'];
        }
      
        
        if(showErrors.length > 0) {
            toast.error(showErrors[0], {position: toast.POSITION.TOP_RIGHT});
        } else {
            formData                        =   {
                ...formData , 
                items                          :   items,
                additional_attributes: additional_attributes
            };
           

            if (this.state.adjustmentDetail) {
                HttpAPICall.withAthorization(
                    'PUT',
                    this.invAdjustmentUrl + '/edit',
                    this.props.access_token,
                    null,
                    formData,
                    (response) => {
                        toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                        this.props.history.push({
                            pathname: `/inventory_adjustment_list`,
                            state: { adjustmentId: response.data.transaction_id }
                        });
                    },
                    (error) => {
                        if (error?.response?.status === 422) {

                            swal({
                                title: "Price Update",
                                text: "Adjustment Average Rate has been changed. Kindly press OK to refresh.",
                                icon: "warning",
                                buttons: {
                                    confirm: "OK"
                                }
                            }).then((confirm) => {

                                if (confirm) {

                                    // ✅ ONLY UPDATE RATE (Adjustment Keys)
                                    const updatedRows = this.state.adjustmentItemRows.map(row => {

                                        if (!row.item || !row.item.id) return row;

                                        return {
                                            ...row,
                                            rate: row.weighted_average_cost || row.rate
                                        };
                                    });

                                    this.setState({
                                        inventoryAdjustmentItemRows: updatedRows
                                    });
                                }
                            });

                            return; // ✅ STOP further execution
                        }

                    }
                ).then(() => this.setState({ saveFormSubmitting: false }));
            } else {
                this.setState({ saveFormSubmitting: true });
                HttpAPICall.withAthorization('POST', this.invAdjustmentUrl + '/add', this.props.access_token, {}, formData, (response) => {
                    toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                    this.props.history.push({ pathname: `/inventory_adjustment_list`, state: { adjustmentId: response.data.transaction_id } })
                }).then(() => this.setState({ saveFormSubmitting: false }));
            }
        }
    }

    pageTitlejsx                        =   ()  =>  {
        return (<div className="page_title row m0">
            <div className="col-12">
                <h3>{this.state.adjustmentDetail ? "Edit" : "Add"} Inventory Adjustment {this.state.adjustmentDetail ? <span> of Transaction ID : {this.state.adjustmentDetail.transaction_id}</span> : null}</h3>
                <div className="text-end mt15">
                    <button onClick={this.closeEvent} disabled={this.state.saveFormSubmitting ? true : false} type="button" className="btn btn-secondary">
                        <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="Close Requisition" />
                    </button>
                </div>
            </div>
        </div>);
    }
  
    saveAdjustmentFormJsx              =   ()  =>  {
        let total_add       =   0;
        let total_subtact   =   0;

        this.state.adjustmentItemRows.forEach((item,key) => {
            if(item && item.item && item.adjustment_type == 'add') {
                    total_add     +=  item.add_qty;
            }
            if(item && item.item && item.adjustment_type == 'subtract') {
                total_subtact     +=  item.subtract_qty;
             }
        });

        return (<form className="bg-white p-3" onSubmit={this.adjustmentFormSubmitHandler}>

            <div className="row align-items-center my-3">
                <div className="col-sm-3">
                    <label htmlFor="site_id" className="form-label require">Date of Transaction</label>
                </div>
                <div className="col-sm-4 add_calender_section">
                    <DatePicker
                        selected={
                            this.state.addAdjustmentForm.transaction_date
                                ? moment(this.state.addAdjustmentForm.transaction_date, 'YYYY-MM-DD').toDate()
                                : false
                        }
                        name="transaction_date"
                        onChange={(value, event) => this.formDateHandler('transaction_date', value, 'addAdjustmentForm')}
                        maxDate={moment(new Date(), 'YYYY-MM-DD').toDate()}
                        dateFormat="dd-MMM-yyyy"
                        className={"form-control"}
                        showMonthDropdown
                        showYearDropdown
                        autoComplete="off"
                        scrollMonthYearDropdown
                        placeholderText={`Please Enter Date of Transaction`}
                        disabled={this.state.isc_prevent_back_day_voucher == 'Y' ? true : false}
                    />
                    <tapIcon.imageIcon icon={tapIcon.CalenderIcon} alt="requisition_date" className="add_calender-icon" />
                </div>
            </div>
            <div className="row align-items-center my-3">
                <div className="col-sm-3">
                    <label htmlFor="warehouse_id" className="form-label require">Warehouse</label>
                </div>
                <div className="col-sm-7">
                    <TapSelect
                        changeEvent={(selectedOption) => {
                            this.tapSelectChange(selectedOption, 'addAdjustmentForm', 'warehouse_id', () => {
                                this.onWarehouseChange(selectedOption);
                            });
                        }}
                        options={this.state.allWarehouses}
                        isSearchable={true}
                        required={true}
                        value={this.state.allWarehouses.find(m => m.value == this.state.addAdjustmentForm.warehouse_id)}
                        placeholder="Please Select Warehouse"
                        isDisabled={this.state.adjustmentDetail}
                    />
                </div>
            </div>
            {this.state.warehouseDetail
                ? <div className="row align-items-center mt1">
                    <div className="offset-3 col-sm-8"><WarehouseAddress warehouseDetail={this.state.warehouseDetail} /></div>
                </div>
                : (this.state.warehouseDetailLoading ? <Loader /> : null)
            }

            <div className="row align-items-center my-3">
                <div className="col-sm-3">
                    <label htmlFor="warehouse_id" className="form-label require">Status</label>
                </div>
                <div className="col-sm-4">
                    <TapSelect
                        changeEvent={(selectedOption) => {
                            this.tapSelectChange(selectedOption, 'addAdjustmentForm', 'status');
                        }}
                        options={this.state.allStatus}
                        isSearchable={true}
                        isClearable={true}
                        required={true}
                        value={this.state.allStatus.find(s => s.value == this.state.addAdjustmentForm.status)}
                        placeholder="Select Status"
                        isDisabled={this.state.adjustmentDetail}
                    />
                </div>
            </div>
            {this.state.formData && this.state.formData.additional_attributes && this.state.formData.additional_attributes.length > 0 && <AdditionalAttributeForm
                    additionalAttributes={this.state.formData.additional_attributes}
                    formState={this.state.addAdjustmentForm}
                    onAttributeChange={(value,attributeName) => {
                        this.setState(() => ({
                            addAdjustmentForm: {
                            ...this.state.addAdjustmentForm,
                            [attributeName]: value
                        }
                    }))}
                } 
                />}
             {this.adjustmentItemsJsx()}
             <div className="row align-items-center my-3">
                <div className="col-sm-6">
                    <label htmlFor="notes" className="form-label">Notes</label>
                    <textarea
                        name="notes"
                        value={this.state.addAdjustmentForm.notes}
                        onChange={(e) => this.formInputHandler(e, 'addAdjustmentForm')}
                        className="form-control"
                        style={{ height: "100px" }}
                    />
                </div>
                <div className="col-sm-6">
                    <table className="table table-borderless">
                        <tbody>
                            <tr className="subtotal_bg_color"><th>Total Qty Added</th><td className="text-end">{parseFloat(total_add).toFixed(2)}</td></tr>
                            <tr className="subtotal_bg_color"><th>Total Qty Subtracted</th><td className="text-end">{parseFloat(total_subtact).toFixed(2)}</td></tr>
                        </tbody>
                    </table>
                </div>
            </div>

           {!this.state.buttonDisabled && <div className="col-12 text-end fixed_footer">
                <button type="button" disabled={this.state.saveFormSubmitting || this.state.buttonDisabled} onClick={this.closeEvent} className="btn btn-secondary ms-2">Cancel</button>
               
                <button type="button" disabled={this.state.saveFormSubmitting || this.state.buttonDisabled} className="btn btn-primary ms-2" onClick={(e) => { this.adjustmentFormSubmitHandler(e, this.state.addAdjustmentForm.status); }}>
                    Save {this.state.saveFormSubmitting ? (<tapIcon.FontAwesomeIcon icon={tapIcon.faSyncAlt} className="fa-spin" />) : ''}
                </button>
            </div>}
        </form>);
    }

    adjustmentItemsJsx                 =   ()  =>  {
        return (<div className="my-3 row">
            <div className="col-sm-12">
                <table className="table table-bordered table-responsive bg-white ">
                    <thead className="table-secondary align-middle">
                        <tr className="">
                            <th scope="col" style={{ width: "5%" }}>S.No</th>
                            <th scope="col">Item Details</th>
                            <th scope="col" className="text-center" style={{ width: "8%" }}>Unit Rate</th>
                            <th scope="col" className="text-center" style={{ width: "12%" }}>Adjustment Type</th>
                            {this.state.track_batch_expiry == "Y" ?
                                <th scope="col" className="text-center" style={{ width: "14%" }}>Batch Number <br /> Expiry Date</th>
                                : null}
                            <th scope="col" className="text-center" style={{ width: "8%" }}>Current Stock</th>
                            <th scope="col" className="text-center" style={{ width: "8%" }}>Add Qty</th>
                            <th scope="col" className="text-center" style={{ width: "8%" }}>Subtract Qty</th>
                            <th scope="col" className="text-center" style={{ width: "8%" }}>New Qty</th>
                            <th scope="col" className="" style={{ width: "6%" }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.adjustmentItemRows.map((itemRow, itemKey) => {
                            let item = itemRow && itemRow.item ? itemRow.item : null;
                           
                            return <tr className="" key={itemKey}>
                                <td className="text-center align-middle">{itemKey + 1}</td>
                                {(item
                                    ? <Ax>
                                        <td>
                                            <div className="row">
                                                <div className='col-sm-10'><span className="fw-bold link-primary cursor_pointer" onClick={() => { this.itemViewModalInit(item) }}>{item.name}</span></div>

                                                <div className='col-sm-2 text-end'>
                                                    <tapIcon.imageIcon icon={tapIcon.ListActionIcon} alt="action-icon" className="img-fluid pr10 pl10" data-bs-toggle="dropdown" href="#" role="button" aria-expanded="false" />
                                                    <ul className="dropdown-menu">
                                                        <li><a href="#" className="dropdown-item" onClick={() => { this.itemViewModalInit(item) }}>View Details</a></li>
                                                        {this.props?.permissions?.permissions?.includes("isc-item-edit") && <li><a href="#" className="dropdown-item" onClick={() => {this.setState({showItemEditModal : false},() => {this.editItemModalInit(item,itemKey)})  }}>Edit Item</a></li>}

                                                        <li className="dropdown-item" onClick={() => { this.addRemark(itemRow.item, itemKey) }}>Add Remark</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="form-text"><b>Code: </b>{item.item_code}</div>
                                            <div className="form-text">
                                                <b>Mfr: </b>{item.manufacturer ? item.manufacturer.name : '-'} (<b>MPN:</b> {item.manufacturer_part_no ? item.manufacturer_part_no : '-'})
                                            </div>
                                            {itemRow.item && itemRow.item.isAddRemark && itemRow.item.isAddRemark == true
                                                ?
                                                <input
                                                    name="remark"
                                                    type="text"
                                                    value={itemRow.remark}
                                                    onChange={(e) => this.dynamicInputHandlerByKey(e, itemKey, 'adjustmentItemRows')}
                                                    className="form-control mt10"
                                                    autoComplete="off"
                                                    placeholder="Item Remarks"
                                                />
                                                : null}

                                        </td>
                                        <td>
                                            <TapInputNumber
                                                name="rate"
                                                value={itemRow.rate}
                                                onChange={(e) => this.dynamicInputHandlerByKey(null, itemKey, 'adjustmentItemRows',null,'rate',e)}
                                                placeholder="Unit Rate"
                                                required={true}
                                                min={0}
                                                disabled={itemRow?.item?.category == "goods" && itemRow.adjustment_type == "subtract" && this.state.isc_item_weighted_average_cost == 'Y' ? true : false}
                                            />
                                        </td>
                                        <td>
                                            <div key={itemKey} className="form-check form-check-inline">
                                                <input
                                                    name={`adjustment_type_${itemKey}`} // Use a unique name for each group
                                                    type="radio"
                                                    value="add"
                                                    onChange={() => this.handleRadioChange(itemKey, 'add', item.id)}
                                                    checked={itemRow.adjustment_type == "add"}
                                                    className="form-check-input"
                                                    id={`adjustmentForm${item.id}Add${itemKey}`}
                                                />
                                                <label className="form-check-label" htmlFor={`adjustmentForm${item.id}Add${itemKey}`}>Add</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input
                                                    name={`adjustment_type_${itemKey}`} // Use the same unique name for both radio buttons in the group
                                                    type="radio"
                                                    value="subtract"
                                                    onChange={() => this.handleRadioChange(itemKey, 'subtract', item.id)}
                                                    checked={itemRow.adjustment_type == "subtract"}
                                                    className="form-check-input"
                                                    id={`adjustmentForm${item.id}Subtract${itemKey}`}
                                                />
                                                <label className="form-check-label" htmlFor={`adjustmentForm${item.id}Subtract${itemKey}`}>Subtract</label>
                                            </div>



                                        </td>
                                        {
                                            itemRow.stock_loading && item.category == "goods"
                                                ? <td colSpan={this.state.track_batch_expiry == 'Y' ? 7 : 6}><Loader /></td>
                                                : (<Ax>

                                                    {this.state.track_batch_expiry == "Y"
                                                        ? <td>
                                                            {item.category == "goods" ? (<Ax>
                                                                {itemRow.adjustment_type == 'add' ? <div>
                                                                    <input
                                                                        className="form-control"
                                                                        placeholder="Batch Number"
                                                                        name="batch_number"
                                                                        type="text"
                                                                        value={this.state.adjustmentItemRows[itemKey].batch_number}
                                                                        onChange={(e) => this.dynamicInputHandlerByKeyNameVal(e.target.value, 'batch_number', itemKey, 'adjustmentItemRows')}
                                                                        autoComplete="off"
                                                                        disabled={item.category == "services" ? true : false}
                                                                    />
                                                                    <br />
                                                                    <DatePicker
                                                                        selected={
                                                                            this.state.adjustmentItemRows[itemKey].expiry_date
                                                                                ? moment(this.state.adjustmentItemRows[itemKey].expiry_date, 'YYYY-MM-DD').toDate()
                                                                                : false
                                                                        }
                                                                        name="expiry_date"
                                                                        onChange={(value, e) =>
                                                                            this.dynamicFormDateHandler(value, 'expiry_date', itemKey, 'adjustmentItemRows')
                                                                        }
                                                                        dateFormat="dd-MMM-yyyy"
                                                                        className={"form-control"}
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                        autoComplete="off"
                                                                        scrollMonthYearDropdown
                                                                        disabled={item.category == "services" ? true : false}
                                                                        placeholderText={`Enter Expiry Date`}
                                                                    />
                                                                </div> :
                                                                    <Ax>
                                                                        {itemRow && itemRow.current_stocks && itemRow.current_stocks.length > 1 ?
                                                                            <TapSelect
                                                                                changeEvent={(selectedOption) => { this.onBatchChange(selectedOption, itemKey); }}
                                                                                options={itemRow.current_stocks}
                                                                                value={itemRow.current_stocks.find((stockOption) => {
                                                                                    return stockOption.stock === itemRow.selected_stock || (
                                                                                        stockOption.stock?.batch_number === itemRow.selected_stock?.batch_number &&
                                                                                        stockOption.stock?.expiry_date === itemRow.selected_stock?.expiry_date
                                                                                    );
                                                                                }) || null}
                                                                                isSearchable={false}
                                                                                placeholder="Change"
                                                                                isDisabled={itemRow && itemRow.consumption_item_id ? true : false}
                                                                            />
                                                                            : null}
                                                                        <div className='py-1'>
                                                                            <b >Batch Number : </b> {itemRow.selected_stock ? itemRow.selected_stock.batch_number : "-"} <br />
                                                                            <b >Expiry Date : </b> {itemRow.selected_stock ? itemRow.selected_stock.expiry_date_display : "-"} <br />

                                                                        </div>
                                                                    </Ax>}
                                                            </Ax>) : (<div className="align-middle text-center">-</div>)}
                                                        </td> : null
                                                    }

                                                    <td className='text-center'>
                                                        {item.category == "services" ? null : <div className={['my-1', (itemRow.selected_stock && itemRow.selected_stock.free_qty < 0) ? 'text-danger' : ''].join(' ')}>
                                                            {itemRow.selected_stock ? itemRow.free_qty : this.state.adjustmentDetail && itemRow.adjustment_type == 'add' ? itemRow.free_qty : "0"}
                                                        </div>}
                                                    </td>
                                                    <td>
                                                        <TapInputNumber
                                                            name="add_qty"
                                                            value={itemRow.add_qty}
                                                            onChange={(e) => {
                                                                this.dynamicInputHandlerByKey(null, itemKey, 'adjustmentItemRows',null,'add_qty',e);
                                                                this.adjustQtyFields(itemKey, 'add_qty', e);
                                                            }}
                                                            placeholder="Add Qty"
                                                            min={0}
                                                            disabled={itemRow.adjustment_type === "subtract" ? true : false}
                                                        />
                                                    </td>
                                                    <td>
                                                        <TapInputNumber
                                                            name="subtract_qty"
                                                            value={itemRow.subtract_qty}
                                                            onChange={(e) => {
                                                                this.dynamicInputHandlerByKey(null, itemKey, 'adjustmentItemRows',null,"subtract_qty",e);
                                                                this.adjustQtyFields(itemKey, 'subtract_qty', e);
                                                            }}
                                                            
                                                            placeholder="Subtract Qty"
                                                            min={0}
                                                            disabled={itemRow.adjustment_type === "add" ? true : false}
                                                        />
                                                    </td>
                                                    <td>
                                                        <TapInputNumber
                                                            name="new_qty"
                                                            value={itemRow.new_qty}
                                                            onChange={(e) => {
                                                                this.dynamicInputHandlerByKey(null, itemKey, 'adjustmentItemRows',null,'new_qty',e);
                                                                this.adjustQtyFields(itemKey, 'new_qty', e);
                                                            }}
                                                            placeholder="New Qty"
                                                            min={0}
                                                        />
                                                    </td>
                                                </Ax>)}
                                    </Ax>
                                    : <Ax>
                                        <td className="align-middle">
                                            <InputItemSearch
                                                changeEvent={(selectedOption) => {
                                                    this.onItemSelect(selectedOption, itemKey);
                                                }}
                                                only_active_item='Y'
                                                warehouse_id={this.state.addAdjustmentForm.warehouse_id}
                                                need_weighted_average_cost={this.state.isc_item_weighted_average_cost == 'Y' ? 'Y' : 'N'}

                                            />
                                        </td>
                                        <td colSpan={this.state.track_batch_expiry == 'Y' ? 7 : 6}></td>
                                    </Ax>
                                )}
                                <td className="text-center align-middle">
                                    {this.state.adjustmentItemRows.length > 1
                                        ? <a href="#" onClick={() => this.removeItemRow(itemKey)}>
                                            <tapIcon.imageIcon icon={tapIcon.CloseCircleIcon} className="img-fluid" />
                                        </a>
                                        : null
                                    }
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>
            <div className="col-sm-12">
                <div className="row">

                    <div className="col-sm-12 text-end">
                        {this.state.addAdjustmentForm && this.state.addAdjustmentForm.warehouse_id ?
                            <a role="button" onClick={() => {this.setState({showItemSearchModal : false},() => this.itemSearchModalInit())}} className="link-primary me-3"><tapIcon.FontAwesomeIcon icon={tapIcon.faSearch} /> Search Item </a>
                            : null}
                        {this.props?.permissions?.permissions?.includes("isc-item-add") && <a role="button" onClick={() => {this.setState({showItemAddModal : false},() => this.addItemModalInit())}} className="link-primary me-3"><tapIcon.FontAwesomeIcon icon={tapIcon.faPlus} /> Add Item</a>}
                        <a role="button" onClick={this.addNewItemRow} className="link-primary"><tapIcon.FontAwesomeIcon icon={tapIcon.faPlus} /> Add Row </a>
                        <button type='button' disabled={!this.state.addAdjustmentForm.warehouse_id} onClick={this.transferBulkUploadModalInit} className="btn btn-link text-decoration-none ms-3">
                                                <tapIcon.FontAwesomeIcon icon={tapIcon.faPlus} /> Add Row Through Excel
                                            </button>
                    </div>

                </div>
            </div>
        </div>);
    }

  
    render                              =   ()  =>  {
        return (<ApplicationLayout>
        <Helmet><title>Add Inventory Adjustment</title></Helmet>
            {this.pageTitlejsx()}
            <div className="container-fluid">
                <div className="page_containt row pl2">
                    <div className="pageTbl col-12 pl4">
                    { this.state.adjustmentFormDataLoaded 
                        ? this.saveAdjustmentFormJsx()
                        : <Loader/>
                    }
                    </div>
                </div>
                {this.transferBulkUploadModalJsx()}
                {this.state.showItemAddModal && <AddItemModal parentProps={this.props} ref={this.addItemModalRef} />}
                {this.state.showItemEditModal && <ItemEditModal parentProps={this.props} ref={this.editItemModalRef} afterSubmitItem={this.submitEditItem} />}
                <ItemDetailsModal ref={this.itemDetailsRef} />
                {this.state.showItemSearchModal && <ItemSearchModal ref={this.itemSearchRef}
                    afterSelectingItems={(selectedItems) => {
                        this.addItemsfromSearch(selectedItems);
                    }}
                />}
            </div>
           
        </ApplicationLayout>);
    }
}

const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        isc_configuration       :   state.app && state.app.isc_configuration ? state.app.isc_configuration : null,
        iam_group_sites         :   state.app && state.app.user_sites ? state.app.group_sites : [],
        permissions            :   state.app.acl_info,
        all_warehouses          :   state.app && state.app.warehouses ? state.app.warehouses : [],
        isc_setting             :   state.app && state.app.isc_setting ? state.app.isc_setting : null,
    };
};

export default connect(mapStateToProps)(InventoryAdjustmentAdd);